import React,{useState,useEffect} from 'react'
import { DoubleRightOutlined,LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import './HomeCompany.css';

export default function HomeCompany() {
  const [companyList, setCompanyList] = React.useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("https://api.360ep.cn/api/news/?type=company").then(res => {      
      setCompanyList(res.data.data);
      setLoading(false);
    });   
  }, []);

  if (loading) {
    return <div><LoadingOutlined /></div>;
  }

  return (
        <div className="home-company">
        {
            companyList.map((item, index) => {
                return (
                    <div className="home-company-item" key={index}>
                    <div className="home-company-info">
                        <div className="home-company-title">
                            <div className='home-company-name'>{item.Company}</div>
                            <div><a href={item.LinkUrl} target='_blank' rel="noopener noreferrer">进入店铺 &gt; </a></div>
                        </div>
                        <div className='home-company-detail'>主营产品：{item.Business}等</div>
                        <div className='home-company-detail'>产品品牌：{item.Brand}</div>
                        <div className='home-company-detail'>
                            <div><span style={{fontSize:"16px",color:"red"}}>案例分享 </span><span>用客户成功的数据说话</span></div>
                            <div><a href="/#/application"><DoubleRightOutlined />查看更多</a></div>
                        </div>
                        <div className='home-company-newslist'>
                            {
                            item.NewsList.map((news,subindex) => {
                                let newsUrl = "https://info.360ep.cn/news/show.php?itemid=" + news.Itemid;
                                return (
                                    <div className='home-company-news' key={subindex}>
                                        <a href={newsUrl} target='_blank' rel="noopener noreferrer"><img src={news.Thumb} alt={news.Title} /> </a>
                                        <p>{news.Title}</p>
                                    </div>
                                )
                            })     
                        }                       
                        </div>
                    </div>           
                </div>    
                )
            })
        }                 
        </div>
  )
}
